import React, { Component } from 'react';

import './Backdrop.css';

class Backdrop extends Component {
  render() {
    const { variant = 'light' } = this.props;

    return (
      <div className={ `backdrop-container-${variant}`}>

      </div>
    )
  }
}

export default Backdrop;